
import React, { useState } from 'react'
import { Settings } from './settings'
import { SidebarFooter } from './footer'
import { WorkspaceModal } from './modals/workspace-modal'
import { WorkspaceHeader } from './workspace-header'
import { SidebarNavigation } from './sidebar-navigation'
import { Workspace } from '../shared/types'
import { FEATURES } from '@/lib/features'
import type { User } from 'better-auth/types'

interface HeaderProps {
  user: User | null
  onLogout: () => void
}

export default function Sidebar({ user, onLogout }: HeaderProps) {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)

  // State for workspace management
  const [isWorkspaceModalOpen, setIsWorkspaceModalOpen] = useState(false)

  // Workspaces state — personal workspace derived from session user
  const [workspaces, setWorkspaces] = useState<Workspace[]>([
    {
      id: '1',
      name: user?.name ? `${user.name}'s workspace` : 'My workspace',
      type: 'Free',
      members: 1,
      isActive: true,
      avatar: (user as { image?: string } | null)?.image ?? undefined,
    },
  ])

  return (
    <aside className="bg-sidebar m-2 flex w-[240px] flex-col rounded-md h-[calc(100vh-1rem)]">
      {/* Workspace Header */}
      <WorkspaceHeader
        setIsSettingsOpen={setIsSettingsOpen}
        openWorkspaceModal={() => setIsWorkspaceModalOpen(true)}
        workspaces={workspaces}
        setWorkspaces={setWorkspaces}
      />

      {/* Settings Modal - Hidden */}
      {/* {isSettingsOpen && <Settings />} */}

      {/* Create Workspace Modal — workspaces are local-only state until the API owns them */}
      {FEATURES.MULTIPLE_WORKSPACES && (
        <WorkspaceModal
          isOpen={isWorkspaceModalOpen}
          onOpenChange={() => setIsWorkspaceModalOpen(false)}
          setIsWorkspaceModalOpen={setIsWorkspaceModalOpen}
          workspaces={workspaces}
          setWorkspaces={setWorkspaces}
        />
      )}

      <div className="flex flex-1 flex-col justify-between px-2 py-4">
        {/* Navigation Links with Folder List */}
        <SidebarNavigation />
      </div>

      {/* Footer */}
      <SidebarFooter openSettings={() => setIsSettingsOpen(true)} user={user} onLogout={onLogout} />
    </aside>
  )
}
